import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import config from "../config/config";

const AddProgram = () => {
  const navigate = useNavigate()
  
  const [formData, setFormData] = useState({
    image: null,
    program: "",
    bannnerHeading: "",
    bannnerSubHeading: "",
    title: "",
    courseList: [
      {
        course: "",
        fees: "",
        eligibility: "",
        applicationDate: "",
      },
    ],
  });

  const handleChange = (e, index, field) => {
    if (index !== undefined) {
      const updatedCourses = [...formData.courseList];
      updatedCourses[index][field] = e.target.value;
      setFormData({ ...formData, courseList: updatedCourses });
    } else {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleImageChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };

  const addCourse = () => {
    setFormData({
      ...formData,
      courseList: [
        ...formData.courseList,
        {
          course: "",
          fees: "",
          eligibility: "",
          applicationDate: "",
        },
      ],
    });
  };

  const removeCourse = (index) => {
    const updatedCourses = [...formData.courseList];
    updatedCourses.splice(index, 1);
    setFormData({ ...formData, courseList: updatedCourses });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = new FormData();
    form.append("image", formData.image);
    form.append("program", formData.program);
    form.append("bannnerHeading", formData.bannnerHeading);
    form.append("bannnerSubHeading", formData.bannnerSubHeading);
    form.append("title", formData.title);
    form.append("courseList", JSON.stringify(formData.courseList));

    try {
      const res = await axios.post(`${config.API_BASE_URL}/api/admin/create_program`, form); // replace with your endpoint
      // alert("Program submitted successfully!");
      if (res.data.code === 201) {
        alert('Program submitted successfully!');
        navigate("/admin/program");
        console.log(res.data);
      } else {
          alert('Error creating course');
          console.error(res.data);
      }
    } catch (err) {
      console.error(err);
      alert("Error submitting form.");
    }
  };

  return (
    <div className="container mt-5 pt-5">
      <div className="row">
        <div className="col-lg-2"></div>
        <div className="col-lg-10">
          <h2>Add New Program</h2>
          <form onSubmit={handleSubmit} encType="multipart/form-data">
            <div className="mb-3">
              <label className="form-label">Program Image</label>
              <input type="file" className="form-control" onChange={handleImageChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Program</label>
              <input type="text" className="form-control" name="program" value={formData.program} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Banner Heading</label>
              <input type="text" className="form-control" name="bannnerHeading" value={formData.bannnerHeading} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Banner Sub Heading</label>
              <input type="text" className="form-control" name="bannnerSubHeading" value={formData.bannnerSubHeading} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Title</label>
              <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} required />
            </div>

            <hr />
            <h5>Course List</h5>
            {formData.courseList.map((course, index) => (
              <div className="border p-3 mb-3" key={index}>
                <div className="row">
                  <div className="col-md-3">
                    <label className="form-label">Course</label>
                    <input type="text" className="form-control" value={course.course} onChange={(e) => handleChange(e, index, "course")} required />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Fees</label>
                    <input type="text" className="form-control" value={course.fees} onChange={(e) => handleChange(e, index, "fees")} required />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Eligibility</label>
                    <input type="text" className="form-control" value={course.eligibility} onChange={(e) => handleChange(e, index, "eligibility")} required />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Application Date</label>
                    <input type="text" className="form-control" value={course.applicationDate} onChange={(e) => handleChange(e, index, "applicationDate")} required />
                  </div>
                </div>
                <button type="button" className="btn btn-danger btn-sm mt-2" onClick={() => removeCourse(index)} disabled={formData.courseList.length === 1}>
                  Remove
                </button>
              </div>
            ))}

            <button type="button" className="btn btn-primary mb-3" onClick={addCourse}>
              Add Course
            </button>

            <br />
            <button type="submit" className="btn btn-success">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddProgram;
